import React, { FunctionComponent } from 'react';
import { Box } from 'rebass/styled-components';
import styled from 'styled-components';
import theme from 'styled-theming';

export interface IButtonIconProps {
  onClick: () => void;
  children: React.ReactNode;
  disabled?: boolean;
  testid?: string;
}

interface IStyledButtonProps {
  disabled?: boolean;
}

const color = theme('mode', {
  light: (props: any) => props.theme.colors.greyMiddle,
  dark: (props: any) => props.theme.colors.cloud,
});

const hoverColor = theme('mode', {
  light: (props: any) => props.theme.colors.periwinkle,
  dark: (props: any) => props.theme.colors.brightCerulean,

});

const ButtonContainer = styled(Box)<IStyledButtonProps>`
  height: 100%;
  width: 100%;
  border-radius: 50%;
  color: ${color};
  background-color: transparent;
  opacity: ${(props) => (props.disabled ? '0.4' : '1')};
  cursor: ${(props) => (props.disabled ? 'not-allowed' : 'pointer')};
  &:hover {
    color: ${(props) => (props.disabled ? color : hoverColor)};
  }
`;

const ButtonIcon: FunctionComponent<IButtonIconProps> = ({
  onClick, disabled, children, testid,
}: IButtonIconProps) => (
  <ButtonContainer
    disabled={disabled}
    onClick={onClick}
    data-testid={testid}
  >
    {children}
  </ButtonContainer>
);

export default ButtonIcon;
